<template>
  <div class="layout" v-if="courseData">
    <topbar title="Scale Academy" :module="subTitle" />
    <div class="content-pane">
      <router-view class="container" />
    </div>
    <div class="scrollbar_spacing"></div>
  </div>
</template>

<script>
import Topbar from "@/components/Topbar.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Layout",
  components: {
    Topbar
  },
  data() {
    return {
      navOpen: false,
      userOpen: false
    };
  },
  async created() {
    let loggedin = await this.$store.state.auth.status.loggedIn;
    if (loggedin) {
      await this.getCourseAction();
    }
    
    if (this.courseData) {
      //console.log("courseData----", this.courseData);
    }
  },
  computed: {
    ...mapGetters("course", {
      courseData: "courseData",
      module: "module"
    }),
    subTitle() {
      if (this.$store.state.courseActive && this.courseData ) {
        return this.courseData.modules[parseInt(this.$route.params.module) - 1].title;
      } else {
        return this.$route.name;
      }
    }
  },
  methods: {
    ...mapActions("course", ["getCourseAction"])
  }
};
</script>

<style lang="scss" scoped>
.layout {
  .content-pane {
    position: absolute;
    top: 90px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    overflow-y: scroll;
    padding: 15px 20px;
    margin: 0px 40px 25px 25px;
    border-radius: 15px 0px 0px 15px;
    background-color: white;
  }

  .content-pane_mobile {
    top: 150px;
  }

  .scrollbar_spacing {
    position: absolute;
    top: 90px;
    right: 25px;
    bottom: 25px;
    width: 15px;
    background-color: white;
    border-radius: 0px 15px 15px 0px;
  }

  .scrollbar_spacing_mobile {
    top: 150px;
  }
}
</style>
